/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { styled } from '@mui/material';

export const TitleWrapper = styled('div')(() => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: '1.5rem',
}));

export const TableWrapper = styled('div')(() => ({
  marginBottom: '2.5rem',
  height: '100%',
}));

export const ListViewStyles = {
  actionsColumn: {
    justifyContent: 'center',
    alignItems: 'center',
  },
};
